import { Logo } from "@/components/Logo";
import { Youtube } from "lucide-react";

const YOUTUBE_CHANNEL = "https://www.youtube.com/@helpsolvethecase";

export function Footer() {
  return (
    <footer className="border-t border-white/10 bg-charcoal mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="flex flex-col md:flex-row justify-between gap-8">
          <div className="max-w-sm">
            <Logo size="sm" />
            <p className="mt-4 text-sm text-white/50 leading-relaxed">
              A collaborative case workspace where enthusiasts and court watchers examine the evidence, build theories, and debate what the facts really show. We keep it respectful — no doxxing, no harassment, and no targeting private individuals.
            </p>
            <a href={YOUTUBE_CHANNEL} target="_blank" rel="noreferrer" data-testid="footer-youtube-link"
              className="mt-5 inline-flex items-center gap-2 px-4 py-2 rounded-sm border border-white/15 text-white/80 hover:border-red-500/50 hover:text-red-500 transition-colors text-sm font-medium">
              <Youtube className="w-4 h-4" /> Watch on YouTube
            </a>
          </div>
          <div className="flex gap-12">
            <div>
              <div className="label-mono mb-3">Community Rules</div>
              <ul className="space-y-2 text-sm text-white/50">
                <li>No harassment or doxxing</li>
                <li>No unsupported accusations</li>
                <li>No contacting case parties</li>
                <li>Educational analysis only</li>
              </ul>
            </div>
            <div>
              <div className="label-mono mb-3">Platform</div>
              <ul className="space-y-2 text-sm text-white/50">
                <li><a href="/affiliate" data-testid="footer-affiliate-link" className="hover:text-gold transition-colors">Affiliate Program</a></li>
                <li><a href="/contact" data-testid="footer-contact-link" className="hover:text-gold transition-colors">Contact Us</a></li>
                <li>Case Workspaces</li>
                <li>AI Assistant</li>
                <li>Detective Notes</li>
                <li>Discussion Boards</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/30 font-mono">
          <span>© {new Date().getFullYear()} Help Solve The Case™. All rights reserved.</span>
          <span>For educational and organizational purposes only.</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
